import { Component } from "@angular/core";

@Component({
  selector: "app-organismos-home",
  templateUrl: "./organismos-home.component.html",
  styleUrls: ["./organismos-home.component.css"],
})
export class OrganismosHomeComponent {}
